import { PointsClubTier } from 'types';

const mapPointsClubTierProp = (pointsClubTier: PointsClubTier) => {
  switch (pointsClubTier) {
    case 'POINTS_CLUB':
      return 'base';
    case 'POINTS_CLUB_PLUS':
      return 'plus';
    default:
      return '';
  }
};

export default mapPointsClubTierProp;
